function reviewsInit() {
  const reviewsContainer = document.querySelector('[data-reviews]')

  if (!reviewsContainer) { return }

  const reviewsContent = reviewsContainer.querySelector('[data-reviews-content]')
  const reviewsLoading = reviewsContainer.querySelector('[data-reviews-loading]')
  const reviewsError = reviewsContainer.querySelector('[data-reviews-error]')
  const loadMoreBtnContainer = reviewsContainer.querySelector('[data-reviews-load]')
  const loadMoreBtn = reviewsContainer.querySelector('[data-reviews-load-btn]')
  const reviewsApiKey = atob(reviewsContainer.dataset.reviewsKey)
  const reviewsFirstFilter = atob(reviewsContainer.dataset.reviewsFirstFilter)
  const reviewsSecondFilter = atob(reviewsContainer.dataset.reviewsSecondFilter)
  const reviewsFirstBatchApiUrl = `https://api.bazaarvoice.com/data/products.json?apiversion=5.4&passkey=${reviewsApiKey}&limit=100&Filter=${reviewsFirstFilter}&Include=reviews&Limit_reviews=5&Sort_reviews=Rating:desc`
  const reviewsSecondBatchApiUrl = `https://api.bazaarvoice.com/data/products.json?apiversion=5.4&passkey=${reviewsApiKey}&limit=100&Filter=${reviewsSecondFilter}&Include=reviews&Limit_reviews=5&Sort_reviews=Rating:desc`

  fetch(reviewsFirstBatchApiUrl, {method: 'GET', headers: {accept: 'application/json'}})
    .then(response => {
      return response.json()
    })
    .then(data => {
      renderReviews(data)
      loadMoreBtnContainer.classList.remove('hidden')
    })
    .catch(error => {
      console.error(error)
      reviewsError.classList.remove('hidden')
    })

  loadMoreBtn.addEventListener('click', () => {
    loadMoreBtnContainer.classList.add('hidden')

    fetch(reviewsSecondBatchApiUrl, {method: 'GET', headers: {accept: 'application/json'}})
      .then(response => {
        return response.json()
      })
      .then(data => {
        renderReviews(data)
      })
      .catch(error => {
        console.error(error)
        reviewsError.classList.remove('hidden')
      })
  })

  function renderReviews(reviewsData) {
    reviewsLoading.classList.remove('hidden')

    try {
      const reviews = reviewsData.Includes.Reviews
      const products = reviewsData.Results

      let reviewElements = ''

      for (const key in reviews) {
        if (reviews.hasOwnProperty(key)) {
          const review = reviews[key]
          const associatedProduct = products.find(product => review.ProductId === product.Id)

          if (review.ModerationStatus !== 'APPROVED' || !associatedProduct) { continue }

          const productName = associatedProduct.Name || review.OriginalProductName

          if (!productName) { continue }

          let stars = ''

          for (let i = 1; i <= review.RatingRange; i++) {
            stars += i <= review.Rating 
              ? '<svg role="presentation" fill="none" focusable="false" width="15" height="15" class="rating__star rating__star--full" viewBox="0 0 15 15"><path d="M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231L2.86475 15L4.125 9.44483L0 5.72949L5.41414 5.2731L7.5 0Z" fill="currentColor"></path></svg>' 
              : '<svg role="presentation" fill="none" focusable="false" width="15" height="15" class="rating__star rating__star--empty" viewBox="0 0 15 15"><path d="M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231L2.86475 15L4.125 9.44483L0 5.72949L5.41414 5.2731L7.5 0Z" fill="currentColor"></path></svg>'
          }

          reviewElements += `
            <div class="reviews__item">
              ${associatedProduct.ProductPageUrl
                ? `<a href="${associatedProduct.ProductPageUrl}" class="reviews__item-name h5 link">${productName}</a>`
                : `<p class="reviews__item-name h5">${productName}<p>`
              }
              ${review.UserNickname 
                ? `<p class="reviews__item-user"><strong>User Name:&nbsp;</strong>${review.UserNickname}</p>` 
                : ''
              }
              ${review.Title 
                ? `<p class="reviews__item-title"><strong>Title:&nbsp;</strong>${review.Title}</p>` 
                : ''
              }
              <div class="reviews__item-rating">
                <p><strong>Rating:&nbsp;</strong></p>
                <div class="rating">
                  <div class="rating__stars" 
                    role="img" 
                    aria-label="${review.Rating} out of ${review.RatingRange} stars">${stars}</div>
                </div>
              </div>
              ${review.ReviewText
                ? `<p class="reviews__item-copy">${review.ReviewText}</p>` 
                : ''
              }
            </div>
          `
        }
      }

      reviewsContent.innerHTML += reviewElements
      reviewsLoading.classList.add('hidden')
    } catch (error) {
      console.error(error)
      reviewsLoading.classList.add('hidden')
      reviewsError.classList.remove('hidden')
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  reviewsInit()
})
